module.exports = __webpack_public_path__ + "static/media/How to create and send a receipt.94151199.png";